import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.bookings
)

export const selectBookings = createSelector(
    baseSelector,
    (state) => state.bookings
)

export const selectBookingsLoading = createSelector(
    baseSelector,
    (state) => state.isBookingsLoading
)

export const selectBookingsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isBookingsFirstLoad
)

export const selectBookingsError = createSelector(
    baseSelector,
    (state) => state.bookingsError
)

export const selectCurrentPage = createSelector(
    baseSelector,
    (state) => state.page
)